export { EditProfileScreen } from './EditProfileScreen';
export type { EditProfileScreenProps } from './EditProfileScreen';
